export const SCANNER_FEATURE_KEY = 'barcodeReader';
export const SCANN_TO_BASKET_FEATURE_KEY = 'scanToBasket';
export const SCAN_FEATURE_KEY = 'scan';
